import { apiV2 } from './axios';
import { toFormData } from './documentTypes';

export type AutoMileageExpense = {
  year: number;
  month: number;
  expense: number;
};

export const insertNewMileage = async (miles: AutoMileageExpense[]) => {
  const { data } = await apiV2.put('auto-mileage-expenses', miles);
  return data;
};

export type CreateExpensesFile = {
  file: any;
  businessId: string;
};

export const createAutoMileageExpensesViaFile = async (
  form: CreateExpensesFile,
) => {
  const { data } = await apiV2.post<FormData, { data: CreateExpensesFile }>(
    'auto-mileage-expenses/upload-file',
    toFormData(form),
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000,
    },
  );
  return data;
};
